import { http } from '@/http/axios.js'

// 列表
export function getListAPI(data) {
  return http({
    url: `/api/manage/staff/user/list`,
    method: 'POST',
    data
  })
}


export function getDetailAPI(id) {
  return http({
    url: `/api/manage/staff/user/detail`,
    method: 'post',
    data: { id }
  })
}

export function giveExpireTimeAPI(uid, day) {
  return http({
    url: `/api/manage/staff/order/giveExpireTime`,
    method: 'post',
    data: {uid, day}
  })
}

export function getUserProductInfo(uid) {
  return http({
    url: `/api/manage/staff/user/getUserProductInfo`,
    method: 'post',
    data: { uid }
  })
}



export function getOrderListAPI(uid) {
  return http({
    url: `/api/manage/staff/order/list`,
    method: 'post',
    data: { uid, pay_status: 20, order_type: 10 }
  })
}

export function getOrderGiveListAPI(uid) {
  return http({
    url: `/api/manage/staff/order/list`,
    method: 'post',
    data: { uid, pay_status: 20, order_type: 20 }
  })
}

export function followLogAddAPI(data) {
  return http({
    url: `/api/manage/staff/user/follow-log/add`,
    method: 'post',
    data
  })
}


export function updateUserInfoAPI(data) {
  return http({
    url: `/api/manage/staff/user/updateUserInfo`,
    method: 'post',
    data
  })
}


export function followLogListAPI(data) {
  return http({
    url: `/api/manage/staff/user/follow-log/list`,
    method: 'post',
    data
  })
}


export function getBrowsingHistoryListAPI(data) {
  return http({
    url: `/api/manage/staff/user/biaoxun/getLookList`,
    method: 'post',
    data
  })
}


